import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Select from '../form/Select'
import Input from '../form/Input'
import CheckboxGroup from '../form/CheckboxGroup'

@observer
class RecordTag extends Component {
    fields = {}

    componentDidMount() {
        const { register } = this.props
        if (!R.isNil(register)) {
            register('recordTag', this.validate)
        }
    }

    componentWillUnmount() {
        const { unregister } = this.props
        if (!R.isNil(unregister)) {
            unregister('recordTag')
        }
    }

    register = (name, validate, path) => {
        this.fields[name] = {
            validate,
            path,
        }
    }

    unregister = (name) => {
        Reflect.deleteProperty(this.fields, name)
    }

    validate = () => {
        const { values } = this.props

        return Object.keys(this.fields)
            .map((key) => (
                this.fields[key].validate({
                    value: values[key],
                    name: key,
                }, true)
            ))
            .every((valid) => valid)
    }

    renderTag = (tag) => {
        const { onBlur, values } = this.props
        const {
            tagId,
            questionType,
            label,
            options,
            isMandatory,
        } = tag

        switch (questionType) {
            case 'SB':
                return (
                    <Select
                        name={tagId}
                        isMandatory={isMandatory}
                        options={options}
                        onBlur={onBlur}
                        label={label}
                        register={this.register}
                        unregister={this.unregister}
                        value={R.pathOr(null, [`${tagId}`], values)}
                    />
                )
            case 'CH':
                return (
                    <CheckboxGroup
                        checkboxClassName="ExploriNativeCheckbox"
                        name={tagId}
                        label={label}
                        isMandatory={isMandatory}
                        options={options}
                        register={this.register}
                        unregister={this.unregister}
                        defaultChecked={R.pathOr([], [`${tagId}`], values)}
                        onBlur={onBlur}
                    />
                )
            case 'TX':
                return (
                    <Input
                        name={tagId}
                        label={label}
                        isMandatory={isMandatory}
                        onChange={onBlur}
                        register={this.register}
                        unregister={this.unregister}
                        value={R.pathOr('', [`${tagId}`], values)}
                    />
                )
            case 'I':
                return (
                    <Input
                        isNumeric
                        label={label}
                        name={tagId}
                        isMandatory={isMandatory}
                        onChange={onBlur}
                        register={this.register}
                        unregister={this.unregister}
                        value={R.pathOr('', [`${tagId}`], values)}
                    />
                )
            default:
                return null
        }
    }

    render() {
        const { availableTags } = this.props
        if (!availableTags) return null
        return (
            <div id="recordTag" style={{ display: 'flex', flexDirection: 'column', gap: '35px' }}>
                {availableTags.map(this.renderTag)}
            </div>
        )
    }
}

export default RecordTag
